<template>
    <div class="expats-page">
        <life-abroad-header></life-abroad-header>
        <welcome-to-czech></welcome-to-czech>
        <prague-banner></prague-banner>
        <brno-banner></brno-banner>
        <section class="section-resting"></section>
        <bonus-grid></bonus-grid>
        <image-banner></image-banner>
        <featured-roles></featured-roles>

    </div>
</template>

<script>
  import LifeAbroadHeader from "../components/expatsPageComponents/ExpatsHeader";
  import CoverImg from "../components/CoverImg";
  import OpenPositions from "../components/home/OpenPositions";
  import WelcomeToCzech from "../components/expatsPageComponents/WelcomeToCzech";
  import BonusGrid from "../components/expatsPageComponents/BonusGrid";
  import ImageBanner from "../components/expatsPageComponents/ImageBanner";
  import PragueBanner from "../components/expatsPageComponents/PragueBanner";
  import BrnoBanner from "../components/expatsPageComponents/BrnoBanner";
  import FeaturedRoles from "../components/common/FeaturedRoles";


  export default {
    components: {
      FeaturedRoles,
      BrnoBanner,
      PragueBanner,
      ImageBanner,
      BonusGrid,
      WelcomeToCzech,
      OpenPositions,
      CoverImg,
      LifeAbroadHeader

    },
    name: "life-abroad",

    metaInfo() {
      return {
        title: "Expats",
        htmlAttrs: {
          lang: "en",
          metaInfo: {
            meta: [
              { charset: "utf-8" },
              { name: "og:title", content: "Expats" },
              { name: "description", content: "Bohemia Interactive Internship page" }
            ]
          }
        }

      };
    }
  };
</script>

<style scoped lang="scss">

    @import "../assets/scss/globals";

    .expats-page {
        position: relative;
    }

    .section-resting {
        background: url('/static/img/expat_page/prague_resting.png');
        background-repeat: no-repeat;
        position: relative;
        background-position-y: 100%;
        height: 670px;

        @media (max-width: $tablet) {
            height: 40vh;
        }

        @media (max-width: 425px) {

            background-size: contain;
        }
    }

</style>


// WEBPACK FOOTER //
// src/pages/ExpatsPage.vue